import { Component, OnDestroy, OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/store/app.reducers';
import { Action } from '@app-models/action.model';

import { TopbarActions } from 'src/app/core/store/actions/topbar/actions';

@Component({
  selector: 'app-actions-menu',
  templateUrl: './actions-menu.component.html',
  styleUrls: ['./actions-menu.component.scss'],
})
export class ActionsMenuComponent implements OnInit, OnDestroy {
  public isMobile;
  public isTablet;
  public isDesktopDevice;

  public isOpen = false;
  private isOpenSubscription: Subscription;

  // Store
  subscription: Subscription = new Subscription();
  public actions: Action[] = [];
  public actionList: Action[] = [];

  constructor(
    private deviceService: DeviceDetectorService,
    private store: Store<AppState>
  ) {}

  ngOnInit(): void {
    this.deviceFunction();

    // Read Actions
    this.subscription = this.store.select('topBar').subscribe(({ actions }) => {
      this.actions = [...actions];
      this.actionList = this.actions.filter((action) => action.type === 'list');
    });
  }

  public setAction(actionFunction) {
    this.store.dispatch({
      type: TopbarActions.TOPBAR_CLICKED_ACTION,
      payload: actionFunction,
    });
  }

  deviceFunction() {
    this.isMobile = this.deviceService.isMobile();
    this.isTablet = this.deviceService.isTablet();
    this.isDesktopDevice = this.deviceService.isDesktop();
  }

  ngOnDestroy() {
    this.isOpenSubscription.unsubscribe();
  }
}
